module.exports = __webpack_public_path__ + "static/fluid-logo-861e9fc5c6860f93315c8a83edb11449.png";